export default __webpack_public_path__ + "static/media/visaa.c9055f91.png";